import { render, staticRenderFns } from "./addTarget.vue?vue&type=template&id=5780df4c&scoped=true&"
import script from "./addTarget.vue?vue&type=script&lang=js&"
export * from "./addTarget.vue?vue&type=script&lang=js&"
import style0 from "./addTarget.vue?vue&type=style&index=0&id=5780df4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5780df4c",
  null
  
)

export default component.exports